export default class AddActivityCtrl {
  constructor ($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv) {
  // constants
    this.$scope = $scope
    this.$scope.parentActivity = WorkPlanModalSrv.getVariable()
    this.WorkPlanModalSrv = WorkPlanModalSrv
    this.$scope.activities = {}
    this.$mdDialog = $mdDialog
    this.ReviewSrv = ReviewSrv

  // variables
    this.numberOfStudentsAdd = ''
    this.hoursExecutedAdd = ''
    this.observationsAdd = ''
    this.listItemId = ''
    this.$scope.listType = ''
    this.isSaveButtonDisabled = false

    this.activate()

  }

    activate () {
      this.$scope.listType = this.$scope.parentActivity.listType
      return this.getActivitiesList()
    }

    clearCombo () {
      let items = this.$scope.parentActivity.children
      for (var i in items) {
        for (var j in this.$scope.activities) {
          if (items[i].itemActivityId === this.$scope.activities[j].idListItem) {
            this.$scope.activities.splice(j, 1)
          }
        }
      }
    }

    close () {
      return this.$mdDialog.hide()
    }

    getActivitiesList () {
      return this.ReviewSrv.getDataFormActivityTeaching.get().$promise.then((dataReturn) => {
        if (dataReturn.status) {
          if (this.$scope.parentActivity.listType === 'planning') {
            this.$scope.activities = dataReturn.listsPlanning.items
          } else {
            this.$scope.activities = dataReturn.listsTeachers.items
          }
          this.clearCombo()
        }
      })
    }

    addActivityNew () {
      this.isSaveButtonDisabled = true
      this.hoursExecutedAdd = (this.hoursExecutedAdd != '') ? this.hoursExecutedAdd : 0
      let header = {
        idActivityParent: this.$scope.parentActivity.idActivityParent,
        idTeacher: this.$scope.parentActivity.idTeacher,
        idWorkPlan: this.$scope.parentActivity.idWorkPlan,
        activityId: this.$scope.parentActivity.activityId,
        asignatureId: this.$scope.parentActivity.asignatureId,
        listItemId: this.listItemId,
        descriptionExecution: this.observationsAdd,
        hoursExecuted: this.hoursExecutedAdd,
        numberOfStudents: this.numberOfStudentsAdd
      }
      this.ReviewSrv.addActivityExecution.post(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          let data = dataReturn.data
          data.name = data.itemActivityName
          delete data.itemActivityName
          data.itemActivityValue = header.numberOfStudents
          this.WorkPlanModalSrv.setVariable(data)
          this.close()
          this.isSaveButtonDisabled = false
        }
      })
    }

    showErrorMessages (input) {
      if (input) {
        return input.$dirty || input.$touched
      } else {
        return false
      }
    }

    validateForm (form) {
      return form.$invalid
    }

    hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }
}

AddActivityCtrl.$inject = ['$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/modals/addActivityCtrl.js